<template>
  <v-container>
    <v-row >
      <v-col>
        <v-alert type="error" transition="scale-transition" v-model="alert" dismissible>
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row >
      <v-col class="pb-0" cols="12" md="6">
          <v-text-field
              label="Image URL / Reddit Post URL"
              placeholder="https://redd.it/xyz"
              outlined
              v-model="url"
              :disabled="!!selectedImage"
              @change="postUrlOnChange"
          ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-file-input
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Upload an image to search"
            prepend-icon="mdi-camera"
            label="Search Image"
            @change="selectFile"
            outlined
        ></v-file-input>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Filters</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" md="6">
                  <v-slider
                      v-model="targetImageMatch"
                      thumb-label
                      class="align-center"
                      max="100"
                      min="20"
                      label="Match Filter"
                      hide-details
                  >

                  </v-slider>
                </v-col>
                <v-col cols="12" md="6">
                  <v-slider
                      v-model="targetImageMemeMatch"
                      thumb-label
                      class="align-center"
                      max="100"
                      min="60"
                      label="Meme Filter"
                      hide-details
                      :disabled="!filterMemeFilter"
                  >

                  </v-slider>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-switch v-model="filterSameSub" :label="`Same Sub`" :disabled="!!selectedImage"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-switch v-model="filterOnlyOlder" :label="`Only Older`" :disabled="!!selectedImage"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-switch v-model="filterIncludeCrosspost" :label="`Include Crossposts`"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-switch v-model="filterMemeFilter" :label="`Meme Filter`"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-switch v-model="filterSameAuthor" :label="`Same Author`" hint="Filter out same author" :disabled="!!selectedImage"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-switch v-model="filterDeadMatches" :label="`Remove Dead Matches`" hint="Filter out deleted posts"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field v-model="targetDaysOld" outlined type="number" :label="`Target Days Old`" hint="0 is unlimited"></v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

        <v-row>
          <v-col cols="2">
              <v-btn-toggle
                  v-model="selectedSort"
                  rounded
                  mandatory
              >
                <v-btn small disabled>
                  Sort
                </v-btn>
                <v-btn small @click="$emit('update-sort', 'date')">
                  Date
                </v-btn>
                <v-btn small @click="$emit('update-sort', 'percent')">
                  Percent
                </v-btn>
              </v-btn-toggle>


          </v-col>
          <v-col cols="10"><v-spacer></v-spacer></v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn :loading="searching" block large color="primary" @click="searchPost" :disabled="(url == null || url === '') && selectedImage == null">Search <v-icon right dark>mdi-image-search</v-icon></v-btn>
          </v-col>
          <v-col>
            <v-btn block large color="normal" @click="setDefaultFilters">Reset <v-icon right dark>mdi-xamarin-outline</v-icon></v-btn>
          </v-col>

        </v-row>

  </v-container>
</template>

<script>
import {getPostIdFromUrl} from "@/util/helpers";
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
const RepostRepo = RepositoryFactory.get('repost')

export default {
  name: "SearchForm",
  props: {
    searchResults: Array[Object],
    sortOrder: String
  },
  data: () => ({
    url: null,
    postTittle: null,
    error: null,
    postId: null,
    targetImageMatch: 90,
    targetImageMemeMatch: 92,
    targetAnnoy: 0.265,
    matches: [],
    filterSameSub: false,
    filterOnlyOlder: false,
    filterIncludeCrosspost: false,
    filterMemeFilter: false,
    filterDeadMatches: false,
    filterSameAuthor: true,
    memeTemplate: null,
    targetDaysOld: 0,
    searching: false,
    alert: false,
    redditPost: {},
    selectedSort: 1,
    imageUpload: null,
    selectedImage: null
  }),
  methods: {
    selectFile(file) {
      this.url = null;
      this.postId = null;
      this.selectedImage = file;
    },
    setDefaultFilters() {
      this.imageUpload = null;
      this.filterSameSub = false;
      this.filterOnlyOlder = false;
      this.filterIncludeCrosspost = false;
      this.filterMemeFilter = false;
      this.filterSameAuthor = true;
      this.searching = false;
      this.targetDaysOld = 0;
      this.selectedImage = null;
      this.url = null;
      this.postId = null
      this.emitSearchResults(null);
    },
    setQueryString() {
      let params = {
        url: this.postId ? undefined : this.url,
        postId: this.postId || undefined,
        memeFilter: this.filterMemeFilter,
        filterDeadMatches: this.filterDeadMatches,
        targetImageMatch: this.targetImageMatch,
        targetImageMemeMatch: this.targetImageMemeMatch,
        targetDaysOld: this.targetDaysOld
      }

      if (!this.selectedImage) {
        params.sameSub = this.filterSameSub;
        params.filterOnlyOlder = this.filterOnlyOlder
        params.filterSameAuthor = this.filterSameAuthor
        params.filterIncludeCrosspost = this.filterIncludeCrosspost
      }
      this.$router.push({name: 'Search', query: params})
    },
    postUrlOnChange: function () {
      this.postId = getPostIdFromUrl(this.url);
      this.setQueryString()
    },
    searchPost: function () {
      this.setQueryString();
      this.searching = true;
      this.emitSearchResults(null);

      let config = {
        params: {
          filter: true,
          url: this.url,
          postId: this.postId,
          same_sub: this.filterSameSub,
          filter_author: this.filterSameAuthor,
          only_older: this.filterOnlyOlder,
          include_crossposts: this.filterIncludeCrosspost,
          meme_filter: this.filterMemeFilter,
          target_match_percent: this.targetImageMatch,
          target_meme_match_percent: this.filterMemeFilter ? this.targetImageMemeMatch : null,
          filter_dead_matches: this.filterDeadMatches,
          target_days_old: this.targetDaysOld
        }
      }

      this.executeSearch(config)
        .then(results => {
          this.searching = false;
          if (results.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: results.data})
            return;
          }
          console.log('Setting matches')
          console.log(results)
          this.matches = results.data.matches;
          this.emitSearchResults(results.data);
        })

    },
    executeSearch(params) {
      if (this.selectedImage !== null) {
        return RepostRepo.getImageRepostsByImage(params, this.selectedImage)
      } else {
        return RepostRepo.getImageReposts(params)
      }
    },
    emitSearchResults(searchResults) {
      console.log('Emitting search results');
      this.$emit('update-search-results', searchResults);
    },
    setFiltersFromQueryParams() {
      console.log(this.$route.query)
      if ('sameSub' in this.$route.query) {
        this.filterSameSub = this.$route.query.sameSub === 'true'
      }
      if ('filterOnlyOlder' in this.$route.query) {
        this.filterOnlyOlder = this.$route.query.filterOnlyOlder === 'true'
      }
      if ('memeFilter' in this.$route.query) {
        console.log('Setting meme filter')
        this.filterMemeFilter = this.$route.query.memeFilter === 'true'
      }
      if ('filterDeadMatches' in this.$route.query) {
        this.filterDeadMatches = this.$route.query.filterDeadMatches === 'true'
      }
      if ('targetImageMatch' in this.$route.query) {
        this.targetImageMatch = parseInt(this.$route.query.targetImageMatch)
      }
      if ('targetImageMemeMatch' in this.$route.query) {
        this.targetImageMemeMatch = parseInt(this.$route.query.targetImageMemeMatch)
      }
      if ('targetDaysOld' in this.$route.query) {
        this.targetDaysOld = parseInt(this.$route.query.targetDaysOld)
      }
      if ('filterSameAuthor' in this.$route.query) {
        this.filterSameAuthor = this.$route.query.filterSameAuthor === 'true'
      }
      if ('filterCrossposts' in this.$route.query) {
        this.filterCrossposts = this.$route.query.filterCrossposts === 'true'
      }
      if ('url' in this.$route.query) {
        this.url = this.$route.query.url
      }
      if ('postId' in this.$route.query) {
        this.postId = this.$route.query.postId
      }

    },

  },
  mounted() {
    this.setFiltersFromQueryParams();
    if ('postId' in this.$route.query) {
      this.url = `https://redd.it/${this.postId}`
      this.searchPost();
    }
  },


}
</script>

<style scoped>
.vue-file-agent.file-input-wrapper {
  border: none !important;
}
</style>
